import { BASE_CONFIG } from '@/workflow/_data/config/config';
import { WORKFLOW_KEYS } from '@/workflow/_pure/keyCodec';
import type { Config, ModeConfig } from '@/workflow-builder/_contract/config';

export const MODE_CONFIG: ModeConfig = {
    writeLocalWorkflowTrace: true,
    nonActiveDimming: {
        enabledByConstellationKey: {
            [WORKFLOW_KEYS.constellations.tool]: true,
        },
        defaultOpacity: 0.2,
    },
};

export const CONFIG: Config = {
    ...BASE_CONFIG,
    adapterMode: 'builder',
    adapterModeConfig: MODE_CONFIG,
};